import React from "react";
import LandingPage from "../src/components/LandingPage";

function App() {
  return <LandingPage />;
}

export default App;
